import endpoint from 'middleware/sagas/endpoint'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getGeneralFeeList: builder.mutation({
      query: body => ({ url: endpoint.pricing.fee.general.index, method: 'POST', body }),
    }),
  }),
})

export const { useGetGeneralFeeListMutation } = extendedApi
